import React, { useState } from 'react';
import AddClient from './AddClient';
import AllClients from './AllClients';
import Client from './Client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './Dashboard';
import { urlContext } from './UrlContext';

function App() {

  //const baseurl = "http://127.0.0.1/clientManagement";
  const baseurl = "https://manage.citywidetechnologiesltd.co.ke";

  return (
    <div className="App">
      <urlContext.Provider value={{baseurl}}>
      <Router>
        <Routes>
          <Route index element={<Dashboard />} />
          <Route path='/addClient' element={<AddClient />} />
          <Route path='/client' element={<Client />} />
          <Route path='/allClients' element={<AllClients />} />
        </Routes>
      </Router>
      </urlContext.Provider>
    </div>
  );
}

export default App;
